import React, { useState } from 'react'
import styled from 'styled-components'
import axios from 'axios'

// components
import { BoxShadow } from '../atom'

// utils
import { useAxios } from '../../utils/useAxios'

// styles
import colors from '../../styles/colors'

function Summary({ singleStat, titleLabel, titleStat, detailStats }) {
  // console.log(singleStat)
  return (
    <>
      <PriceWrapper>
        <span>사장님, {titleLabel}은</span>
        <div>
          <span>{titleStat}</span>
          <span> 입니다.</span>
        </div>
      </PriceWrapper>
      {singleStat == undefined ? (
        <BoxShadow paddingVertical={21} paddingHorizontal={10}>
          <InfoWrapper>
            {detailStats?.map((ele, idx) => (
              <div key={idx}>
                <span>{ele.sub}</span>
                <span>
                  <h1>{ele.main}</h1>
                  <h2>&nbsp;{`건`}</h2>
                  {/* <h2>&nbsp;{ele.sub.includes('율') ? '%' : '건'}</h2> */}
                </span>
              </div>
            ))}
          </InfoWrapper>
        </BoxShadow>
      ) : (
        <></>
      )}
    </>
  )
}

export default Summary

const PriceWrapper = styled.div`
  width: 100%;
  min-width: 320px;
  max-width: 768px;
  display: flex;
  flex-direction: column;
  margin: 45px 0 35px;

  @media ${(props) => props.theme.mobile} {
    margin: 38px 0 30px;
  }

  span:nth-child(1) {
    color: ${colors.BK};
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: 700;

    @media ${(props) => props.theme.mobile} {
      font-size: 14px;
    }
  }

  div {
    span:nth-child(1) {
      color: ${colors.mainG};
      font-weight: 700;
      font-size: 30px;

      @media ${(props) => props.theme.mobile} {
        font-size: 20px;
      }
    }

    span:nth-child(2) {
      color: ${colors.BK};
      font-weight: 700;
      font-size: 30px;

      @media ${(props) => props.theme.mobile} {
        font-size: 20px;
      }
    }
  }
`

const InfoWrapper = styled.div`
  display: flex;
  margin: 20px 0 16px;

  @media ${(props) => props.theme.mobile} {
    margin: 3px 0 1px;
  }

  div {
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;
  }

  span:nth-child(1) {
    color: ${colors.BK};
    margin-bottom: 9px;
    font-size: 16px;

    @media ${(props) => props.theme.mobile} {
      font-size: 12px;
      margin-bottom: 10px;
    }
  }

  span:nth-child(2) {
    color: ${colors.BK};

    display: flex;
    align-items: center;

    h1 {
      font-weight: bold;
      font-size: 22px;

      @media ${(props) => props.theme.mobile} {
        font-size: 16px;
      }
    }

    h2 {
      font-weight: 400;
      font-size: 16px;

      @media ${(props) => props.theme.mobile} {
        font-size: 14px;
      }
    }
  }
`
